import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cbc-navy via-cbc-dark-blue to-cbc-navy p-4">
      <div className="text-center max-w-md rounded-3xl border border-cbc-medium-blue/20 bg-cbc-dark-blue/35 backdrop-blur-xl shadow-cbc-dark px-8 py-10">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-cbc-primary mb-4">404</h1>
          <h2 className="text-3xl font-bold text-cbc-paper mb-2">
            Página no encontrada
          </h2>
          <p className="text-cbc-light-blue/75 mb-8">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-cbc-primary text-cbc-paper rounded-xl hover:bg-cbc-dark-blue transition-colors font-medium shadow-cbc"
          >
            Volver al inicio
          </Link>
        </div>

        <div className="mt-8">
          <svg className="w-64 h-64 mx-auto text-cbc-medium-blue/35" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
    </div>
  )
}
